import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class UtilService {

  constructor(private router: Router) { }
  navigate (pageName:string){
    this.router.navigate([`/${pageName}`])
  }
  
  navigateWithState(pageName:string, form:any) {
    let urlState;

    urlState = {
      form: form,
    };
    localStorage.setItem('urlState', JSON.stringify(urlState));

    this.router.navigate([`/${pageName}`], {
      state: {
        form: form,
      }
    });
  }
  
}
